import { render } from "./WidgetTheme.vue?vue&type=template&id=3bbe36d9"
import script from "./WidgetTheme.vue?vue&type=script&lang=js"
export * from "./WidgetTheme.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__